export default "__VITE_ASSET__CQ7PHeX9__"